import type { SVGProps } from 'react';

interface BarleyIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function BarleyIcon({ className, ...props }: BarleyIconProps) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <path d="M5.13139 13.805C4.30732 14.1789 3.4281 14.4169 2.52791 14.5097C2.46847 14.5159 2.40852 14.5046 2.35537 14.4773C2.30223 14.45 2.25819 14.4078 2.22863 14.3558C1.5616 13.1803 1.34233 11.7178 1.61314 10.113C1.95858 8.04194 3.08184 5.9686 4.77672 4.27376C6.47161 2.57893 8.54655 1.45571 10.6161 1.11028C12.3695 0.818709 13.9528 1.11028 15.1776 1.92577C15.2277 1.95869 15.2671 2.00553 15.291 2.06054C15.3149 2.11555 15.3221 2.17633 15.3119 2.23542C15.3017 2.2945 15.2744 2.34932 15.2335 2.39312C15.1925 2.43693 15.1397 2.46782 15.0814 2.482C14.5049 2.61943 13.9427 2.81161 13.4027 3.05592C11.7278 3.81755 9.58672 5.44545 8.90045 8.87974C8.43038 11.2093 7.16326 12.8664 5.13139 13.805ZM16.7709 3.64292C16.7414 3.59111 16.6975 3.54899 16.6445 3.52168C16.5915 3.49436 16.5317 3.48303 16.4724 3.48905C15.5719 3.58119 14.6923 3.8192 13.8682 4.19375C11.8363 5.13234 10.5692 6.78947 10.103 9.11746C9.41592 12.5517 7.27558 14.1796 5.6007 14.9413C5.06067 15.1856 4.49854 15.3778 3.92197 15.5152C3.8624 15.5286 3.80817 15.5595 3.76619 15.6038C3.72421 15.6482 3.69638 15.704 3.68623 15.7643C3.67609 15.8245 3.68409 15.8863 3.70921 15.942C3.73434 15.9977 3.77546 16.0446 3.82734 16.0768C4.74056 16.6861 5.85228 17 7.08555 17C7.52176 16.9987 7.95714 16.9617 8.3873 16.8892C10.4576 16.5438 12.5318 15.4206 14.2267 13.7257C15.9216 12.0309 17.0448 9.95603 17.3903 7.88653C17.6549 6.28171 17.438 4.81845 16.7709 3.64292Z" fill="currentColor" />
    </svg>
  );
}
